
const LIMIT = 6
export default {
  name: 'PagesMediaCenterCommunity',
  props: {
    community: {
      type: Object,
      default: null,
    },
    contentType: {
      type: String,
      default: 'video',
    },
  },

  data() {
    return {
      type: this.contentType,
      posts: [],
      postsCount: 0,
      postsOffset: 0,
      currentStream: null,
      isNavFits: true,
      isVisibleAllCollections: false,
      isFetch: false,
    }
  },
  computed: {
    communityStreams() {
      this.setIsNavFits()
      if (this.community?.streams?.length) {
        const streams = JSON.parse(JSON.stringify(this.community.streams))
        if (this.type === 'video') {
          return streams
            .filter((stream) => stream.statistics.video.publishedCount > 0)
            .sort(
              (stream1, stream2) =>
                Number(this.isInSubscription(stream2._id)) -
                Number(this.isInSubscription(stream1._id))
            )
        } else {
          return streams
            .filter((stream) => stream.statistics.articles.publishedCount > 0)
            .sort(
              (stream1, stream2) =>
                Number(this.isInSubscription(stream2._id)) -
                Number(this.isInSubscription(stream1._id))
            )
        }
      } else {
        return []
      }
    },
  },
  watch: {
    type() {
      this.currentStream = null
      this.posts = []
      this.postsOffset = 0
      if (this.isFetch) {
        this.fetchData()
      }
    },
  },

  methods: {
    async inView({ isInView }) {
      if (isInView && !this.isFetch) {
        await this.fetchData()
        this.isFetch = true
      }
    },

    async fetchData() {
      if (this.currentStream) {
        await this.fetchByStream()
      } else if (this.type === 'video') {
        await this.fetchVideos()
      } else if (this.type === 'article') {
        await this.fetchArticles()
      }
    },
    isInSubscription(id) {
      if (this.$auth.loggedIn) {
        return !!this.$auth.user.subscriptions?.streams?.find(
          (subscription) => {
            return subscription.stream === id
          }
        )
      } else {
        return false
      }
    },
    setIsNavFits() {
      if (process.client) {
        this.$nextTick(() => {
          const navList = this.$refs.navList
          const navWrap = this.$refs.navWrap
          this.isNavFits = navList?.scrollWidth <= navWrap?.clientWidth
        })
      }
    },
    async fetchVideos() {
      const streamsIds = this.community.streams?.map((stream) => stream._id)
      const { articles, countAllPublishedArticles } = await this.$axios.$get(
        '/articles/streams/video',
        {
          params: {
            streams: streamsIds,
            limit: LIMIT,
            offset: this.postsOffset,
          },
        }
      )

      this.posts = this.posts?.length ? this.posts.concat(articles) : articles
      this.postsCount = countAllPublishedArticles
    },
    async fetchArticles() {
      const streamsIds = this.community.streams?.map((stream) => stream._id)
      const { articles, countAllPublishedArticles } = await this.$axios.$get(
        '/articles/streams/article',
        {
          params: {
            streams: streamsIds,
            limit: LIMIT,
            offset: this.postsOffset,
          },
        }
      )

      this.posts = this.posts?.length ? this.posts.concat(articles) : articles
      this.postsCount = countAllPublishedArticles
    },

    async fetchByStream(stream = this.currentStream) {
      // Только нужные поля
      const filteredFields = {
        article: {
          _id: true,
          publishDate: true,
          title: true,
          description: true,
          source: true,
        },
        author: {
          _id: true,
          username: true,
          type: true,
          'profile.avatar': true,
          'profile.firstName': true,
          'profile.lastName': true,
          'company.avatar': true,
          'company.title': true,
        },
      }

      const { articles, countAllPublishedArticles } = await this.$axios.$get(
        `/articles/stream/${this.type}/${stream}`,
        {
          params: {
            limit: LIMIT,
            offset: this.postsOffset,
            filter: filteredFields,
          },
        }
      )

      this.posts = this.posts?.length ? this.posts.concat(articles) : articles
      this.postsCount = countAllPublishedArticles
    },
    loadMore() {
      this.postsOffset = this.postsOffset + LIMIT
      this.fetchData()
    },
    async setStream(streamUrl) {
      this.currentStream = streamUrl
      this.posts = []
      this.postsCount = 0
      this.postsOffset = 0
      if (this.currentStream) {
        await this.fetchByStream(streamUrl)
      } else {
        this.fetchData()
      }
    },
    updateSettings() {
      this.posts = []
      this.postsCount = 0
      this.postsOffset = 0
      this.fetchData()
    },
  },
}
